export default{
    lista:{
        method:'get',
        url:'fatura/lista'
    },
    pesquisa:{
        method:'get',
        url:'fatura/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'fatura/cadastro'
    },
    delete:{
        method:'delete',
        url:'fatura/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'fatura/editar{/id}'
    },
    update:{
        method:'post',
        url:'fatura/update'
    },
    buscaboletim:{
        method:'post',
        url:'boletins/tabela/fatura/sevico'
    },
    taxas:{
        method:'post',
        url:'fatura/taxas'
    },
    cadastrademostrativo:{
        method:'post',
        url:'faturademostrativa/cadastro'
    },
    rublicas:{
        method:'post',
        url:'faturademostrativa/busca/rublica'
    },
    rublicascadastro:{
        method:'post',
        url:'faturademostrativa/rublica/cadastro'
    },
    trabalhadores:{
        method:'post',
        url:'boletins/tabela/fatura/trabalhadores'
    },
    statuspagamento:{
        method:'post',
        url:'fatura/pagamento/status'
    },
}